<template>
  <div
    style="width:100%; height:100%; display:flex; background:white"
    v-show="forms.AssetId !== undefined && forms.JenisAsset == 'tanah'"
  >
    <div style="width:300px; height:300px; background:silver;">
      <Map
        :strval.sync="forms.Lokasi"
        width="300px"
        height="300px"
        :searchbox="true"
      />
      <div style="border-bottom: 1px solid silver">
        <Uploader @change="UploadPotensi" accept=".kml">
          <template v-slot="{ opener }">
            <v-btn text color="primary" @click="opener">UPLOAD POTENSI</v-btn>
          </template>
        </Uploader>
      </div>
    </div>
    <div style="padding:10px; width:calc(100vw - 600px)" class="form-inline">
      <Input type="text" label="Nama Asset" :value="forms.NamaAsset" />
      <Input type="text" label="No. Asset" :value="forms.NoAsset" />
      <TextArea type="text" label="Alamat" :value="forms.Alamat" />
      <Input type="text" label="Luas" :value="forms.Luas" />
      <Input
        type="text"
        label="Tahun Pengadaan"
        :value="forms.TahunPengadaan"
      />
      <Input type="text" label="Status Tanah" :value="forms.StatusTanah" />
      <Input type="text" label="Tgl. Sertifikat" :value="forms.TglSertifikat" />
      <Input type="text" label="No. Sertifikat" :value="forms.NoSertifikat" />
      <Input type="text" label="Penggunaan" :value="forms.Penggunaan" />
      <Input type="text" label="Asal Usul" :value="forms.AsalUsul" />
      <Input type="text" label="Harga" :value="forms.Harga" />
      <TextArea type="text" label="Keterangan" :value="forms.Keterangan" />
      <v-btn color="primary" @click="Save">SIMPAN</v-btn>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({}),
  props: {
    forms: Object,
  },
  mounted() {
    this.$api.Authorize()
  },
  methods: {
    UploadPotensi(file) {
      this.$api.post('/api/asset/read-potensi', {
        File: file.data,
      })
    },
    Save() {},
  },
}
</script>
